import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { OwnNameInput } from '@kanos/domain';
import { SaveBar, TextField, useToast } from '@kanos/ui';
import { useState } from 'react';
import { Page } from './area-page.js';
import { Card, ProblemAlert } from './card.js';
import { checkForm } from './form.js';
import { useRenameSelf } from './own-account.js';
import { useUnsavedChanges } from './unsaved.js';
/** The name as the sign-in keeps it; from the display name only where its parts are missing. */
function savedName(me) {
    const [first = '', ...rest] = (me.displayName ?? '').trim().split(/\s+/);
    return { firstName: me.firstName ?? first, lastName: me.lastName ?? rest.join(' ') };
}
/**
 * „Persönliche Daten“ (after Corly): the name, changed here in Kanos and saved on the page, not
 * at Keycloak (ADR-058). The address one signs in with is a tab of „Anmeldung & Sicherheit“.
 */
export function PersonalPage({ me }) {
    const saved = savedName(me);
    const [name, setName] = useState(saved);
    const [tried, setTried] = useState(false);
    const rename = useRenameSelf();
    const toast = useToast();
    const dirty = name.firstName !== saved.firstName || name.lastName !== saved.lastName;
    useUnsavedChanges(dirty);
    const save = () => {
        setTried(true);
        const input = checkForm(OwnNameInput, name);
        if (!input)
            return;
        rename.mutate(input, {
            onSuccess: () => {
                setName(input);
                setTried(false);
                toast({ tone: 'success', title: 'Name gespeichert' });
            },
        });
    };
    const missing = (value) => tried && value.trim() === '';
    return (_jsx(Page, { title: "Pers\u00F6nliche Daten", children: _jsxs("div", { className: "grid max-w-3xl gap-4", children: [_jsxs(Card, { id: "personal-name", title: "Name", description: "So nennt Kanos Sie \u2013 in Aufnahmen, Notizen, im Protokoll und in den Teamlisten.", children: [_jsxs("div", { className: "grid gap-4 sm:grid-cols-2", children: [_jsx(TextField, { label: "Vorname", placeholder: "z. B. Martina", value: name.firstName, onChange: (firstName) => setName({ ...name, firstName }), isRequired: true, maxLength: 100, autoComplete: "given-name", isInvalid: missing(name.firstName), errorMessage: "Bitte Ihren Vornamen angeben." }), _jsx(TextField, { label: "Nachname", placeholder: "z. B. Peters", value: name.lastName, onChange: (lastName) => setName({ ...name, lastName }), isRequired: true, maxLength: 100, autoComplete: "family-name", isInvalid: missing(name.lastName), errorMessage: "Bitte Ihren Nachnamen angeben." })] }), rename.isError && _jsx(ProblemAlert, { error: rename.error })] }), _jsx(SaveBar, { dirty: dirty, isPending: rename.isPending, saveLabel: "Speichern", onSave: save, onDiscard: () => {
                        setName(saved);
                        setTried(false);
                        rename.reset();
                    } })] }) }));
}
//# sourceMappingURL=profile.js.map